import React from 'react';
import { getParameterByName } from '../../components/ControlPanel/ControlPanel';

const useAppContext = () => {
  const hasDevice = Boolean(getParameterByName('deviceId') as string);
  const sessionId = getParameterByName('sessionUUID') as string;
  const treatmentId = getParameterByName('treatmentUUID') as string;

  return {
    sessionId,
    treatmentId,
    hasDevice,
  };
};

export default useAppContext;
